import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { esRutaMobile } from "../../constants/rutasMobile";
import { useAuthContext } from "../../context/auth";
import { getLogoByPais } from "../../utils/getLogoByPais";
import styles from "./SoloEscritorio.module.scss";

// Umbral único (F1 de la auditoría de anchos/mobile, decisión de Ignacio §9): 768px, el breakpoint
// "md" de Bootstrap. No repetir este número en ningún otro lugar — importar esta constante.
export const UMBRAL_MOBILE_PX = 768;
const MEDIA_QUERY_MOBILE = `(max-width: ${UMBRAL_MOBILE_PX - 0.02}px)`;

const SESSION_KEY = "adigital_solo_escritorio_ver_igual";

const leerVerIgual = () => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1";
  } catch {
    // Sin sessionStorage no se puede recordar la elección — mejor mostrar el contenido que bloquear.
    return true;
  }
};

const guardarVerIgual = () => {
  try {
    sessionStorage.setItem(SESSION_KEY, "1");
  } catch {
    // No hay dónde recordar la elección; el botón igual muestra el contenido en esta carga.
  }
};

const useVentanaAngosta = () => {
  const [angosta, setAngosta] = useState(() => window.matchMedia(MEDIA_QUERY_MOBILE).matches);

  useEffect(() => {
    const mql = window.matchMedia(MEDIA_QUERY_MOBILE);
    const onChange = (event) => setAngosta(event.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return angosta;
};

const EMOJIS_FONDO = ["🏢", "📊", "💻", "✨", "📈"];
const CANTIDAD_EMOJIS_FONDO = 48;

// Envuelve las rutas de la app (montado una sola vez en src/App.js). En ventana angosta (< 768px)
// y ruta fuera de la lista blanca (src/constants/rutasMobile.js), muestra un aviso amigable en vez
// del contenido — no toca el contenido de ninguna pantalla. Ficha: docs/componentes/solo-escritorio.md.
export const SoloEscritorio = ({ children }) => {
  const { pathname } = useLocation();
  const { pais } = useAuthContext();
  const angosta = useVentanaAngosta();
  const [verIgual, setVerIgual] = useState(leerVerIgual);

  const logo = useMemo(() => getLogoByPais(pais), [pais]);

  const handleVerIgual = useCallback(() => {
    guardarVerIgual();
    setVerIgual(true);
  }, []);

  const mostrarAviso = angosta && !esRutaMobile(pathname) && !verIgual;

  if (!mostrarAviso) return children;

  return (
    <div className={styles.aviso}>
      <div className={styles.fondoEmojis} aria-hidden="true">
        {Array.from({ length: CANTIDAD_EMOJIS_FONDO }).map((_, i) => (
          <span key={i}>{EMOJIS_FONDO[i % EMOJIS_FONDO.length]}</span>
        ))}
      </div>
      <div className={styles.tarjeta}>
        <img src={logo} alt="Logo" className={styles.logo} />
        <h1 className={styles.titulo}>Esta sección se disfruta más en la compu 💻</h1>
        <p className={styles.texto}>
          La armamos pensando en pantallas grandes, con tablas y detalles que en el celular no se ven bien. Ábrela desde
          tu computadora y te va a encantar.
        </p>
        <button type="button" className={styles.boton} onClick={handleVerIgual}>
          Ver igual
        </button>
      </div>
    </div>
  );
};
